import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuthContext, AuthProvider } from './contexts/auth';
import { ThemeProvider } from './contexts/theme';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Home from './pages/Home';
import AddItem from './pages/AddItem';
import Profile from './pages/Profile';
import Discover from './pages/Discover';
import Saved from './pages/Saved';
import DebugStorage from './pages/DebugStorage';
import TryOn from './pages/TryOn';
import Roadmap from './pages/Roadmap';
import RoadmapTab from './components/RoadmapTab';
import { ProtectedRoute } from './components/ProtectedRoute';

// Import font styles
import './assets/fonts.css';

// Component to render authenticated UI elements
function AuthenticatedUI() {
  const { session } = useAuthContext();
  const location = useLocation();
  const pathname = location.pathname;
  
  // Only show the RoadmapTab on these pages (which have the FeedbackWidget)
  const pagesWithFeedback = ['/home', '/discover', '/try-on', '/roadmap'];
  const shouldShowRoadmapTab = pagesWithFeedback.includes(pathname);
  
  if (!session) return null;
  
  return (
    <>
      {shouldShowRoadmapTab && <RoadmapTab />}
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <ThemeProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/" element={<Navigate to="/discover" />} />
            <Route 
              path="/home" 
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              } 
            />
            {/* <Route 
              path="/add" 
              element={
                <ProtectedRoute>
                  <AddItem />
                </ProtectedRoute>
              } 
            /> */}
            {/* <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } 
            /> */}
            <Route 
              path="/discover" 
              element={
                <ProtectedRoute>
                  <Discover />
                </ProtectedRoute>
              } 
            />
            {/* <Route 
              path="/saved" 
              element={
                <ProtectedRoute>
                  <Saved />
                </ProtectedRoute>
              } 
            /> */}
            <Route 
              path="/try-on" 
              element={
                <ProtectedRoute>
                  <TryOn />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/roadmap" 
              element={
                <ProtectedRoute>
                  <Roadmap />
                </ProtectedRoute>
              } 
            />
            {/* <Route 
              path="/debug-storage" 
              element={
                <ProtectedRoute>
                  <DebugStorage />
                </ProtectedRoute>
              } 
            /> */}
            <Route path="*" element={<Navigate to="/discover" />} />
          </Routes>
          <AuthenticatedUI />
        </ThemeProvider>
      </AuthProvider>
    </Router>
  );
} 